"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OevDapiServer__factory = void 0;
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
const ethers_1 = require("ethers");
const _abi = [
    {
        inputs: [
            {
                internalType: "address",
                name: "_accessControlRegistry",
                type: "address",
            },
            {
                internalType: "string",
                name: "_adminRoleDescription",
                type: "string",
            },
            {
                internalType: "address",
                name: "_manager",
                type: "address",
            },
        ],
        stateMutability: "nonpayable",
        type: "constructor",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "bytes32",
                name: "dataFeedId",
                type: "bytes32",
            },
            {
                indexed: true,
                internalType: "bytes32",
                name: "dapiName",
                type: "bytes32",
            },
            {
                indexed: false,
                internalType: "address",
                name: "sender",
                type: "address",
            },
        ],
        name: "SetDapiName",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "bytes32",
                name: "beaconSetId",
                type: "bytes32",
            },
            {
                indexed: false,
                internalType: "int224",
                name: "value",
                type: "int224",
            },
            {
                indexed: false,
                internalType: "uint32",
                name: "timestamp",
                type: "uint32",
            },
        ],
        name: "UpdatedBeaconSetWithBeacons",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "bytes32",
                name: "beaconId",
                type: "bytes32",
            },
            {
                indexed: false,
                internalType: "int224",
                name: "value",
                type: "int224",
            },
            {
                indexed: false,
                internalType: "uint32",
                name: "timestamp",
                type: "uint32",
            },
        ],
        name: "UpdatedBeaconWithSignedData",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "bytes32",
                name: "beaconSetId",
                type: "bytes32",
            },
            {
                indexed: true,
                internalType: "address",
                name: "proxy",
                type: "address",
            },
            {
                indexed: true,
                internalType: "bytes32",
                name: "updateId",
                type: "bytes32",
            },
            {
                indexed: false,
                internalType: "int224",
                name: "value",
                type: "int224",
            },
            {
                indexed: false,
                internalType: "uint32",
                name: "timestamp",
                type: "uint32",
            },
        ],
        name: "UpdatedOevProxyBeaconSetWithSignedData",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "bytes32",
                name: "beaconId",
                type: "bytes32",
            },
            {
                indexed: true,
                internalType: "address",
                name: "proxy",
                type: "address",
            },
            {
                indexed: true,
                internalType: "bytes32",
                name: "updateId",
                type: "bytes32",
            },
            {
                indexed: false,
                internalType: "int224",
                name: "value",
                type: "int224",
            },
            {
                indexed: false,
                internalType: "uint32",
                name: "timestamp",
                type: "uint32",
            },
        ],
        name: "UpdatedOevProxyBeaconWithSignedData",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "oevProxy",
                type: "address",
            },
            {
                indexed: false,
                internalType: "address",
                name: "oevBeneficiary",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "Withdrew",
        type: "event",
    },
    {
        inputs: [],
        name: "DAPI_NAME_SETTER_ROLE_DESCRIPTION",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "accessControlRegistry",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "adminRole",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "adminRoleDescription",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "containsBytecode",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        name: "dapiNameHashToDataFeedId",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "dapiNameSetterRole",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "dapiName",
                type: "bytes32",
            },
        ],
        name: "dapiNameToDataFeedId",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "getBalance",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "getBlockBasefee",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "getBlockNumber",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "getBlockTimestamp",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "getChainId",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "manager",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes[]",
                name: "data",
                type: "bytes[]",
            },
        ],
        name: "multicall",
        outputs: [
            {
                internalType: "bytes[]",
                name: "returndata",
                type: "bytes[]",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "oevProxyToBalance",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "dapiName",
                type: "bytes32",
            },
            {
                internalType: "bytes32",
                name: "dataFeedId",
                type: "bytes32",
            },
        ],
        name: "setDapiName",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes[]",
                name: "data",
                type: "bytes[]",
            },
        ],
        name: "tryMulticall",
        outputs: [
            {
                internalType: "bool[]",
                name: "successes",
                type: "bool[]",
            },
            {
                internalType: "bytes[]",
                name: "returndata",
                type: "bytes[]",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32[]",
                name: "beaconIds",
                type: "bytes32[]",
            },
        ],
        name: "updateBeaconSetWithBeacons",
        outputs: [
            {
                internalType: "bytes32",
                name: "beaconSetId",
                type: "bytes32",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "oevProxy",
                type: "address",
            },
            {
                internalType: "bytes32",
                name: "dataFeedId",
                type: "bytes32",
            },
            {
                internalType: "bytes32",
                name: "updateId",
                type: "bytes32",
            },
            {
                internalType: "uint256",
                name: "timestamp",
                type: "uint256",
            },
            {
                internalType: "bytes",
                name: "data",
                type: "bytes",
            },
            {
                internalType: "bytes[]",
                name: "packedOevUpdateSignatures",
                type: "bytes[]",
            },
        ],
        name: "updateOevProxyDataFeedWithSignedData",
        outputs: [],
        stateMutability: "payable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "oevProxy",
                type: "address",
            },
        ],
        name: "withdraw",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
];
const _bytecode = "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";
const isSuperArgs = (xs) => xs.length > 1;
class OevDapiServer__factory extends ethers_1.ContractFactory {
    constructor(...args) {
        if (isSuperArgs(args)) {
            super(...args);
        }
        else {
            super(_abi, _bytecode, args[0]);
        }
    }
    getDeployTransaction(_accessControlRegistry, _adminRoleDescription, _manager, overrides) {
        return super.getDeployTransaction(_accessControlRegistry, _adminRoleDescription, _manager, overrides || {});
    }
    deploy(_accessControlRegistry, _adminRoleDescription, _manager, overrides) {
        return super.deploy(_accessControlRegistry, _adminRoleDescription, _manager, overrides || {});
    }
    connect(runner) {
        return super.connect(runner);
    }
    static bytecode = _bytecode;
    static abi = _abi;
    static createInterface() {
        return new ethers_1.Interface(_abi);
    }
    static connect(address, runner) {
        return new ethers_1.Contract(address, _abi, runner);
    }
}
exports.OevDapiServer__factory = OevDapiServer__factory;
//# sourceMappingURL=OevDapiServer__factory.js.map